<template>
<div class="container">

<div class="row center empty" v-show="!list||list.length==0">
  <i class="fa fa-address-book-o"></i>
  <p>暂无常用体检人</p>
</div>

<div class="myitem" v-for="(v,i) in list">
  <div class="row">
  	<div class="col-3">姓名</div>
  	<div class="col-7">{{v.realname}}</div>
  </div>	
  <div class="row">
  	<div class="col-3">性别</div>
  	<div class="col-7">{{v.sex|sex}}</div>
  </div>
  <div class="row">
  	<div class="col-3">手机号码</div>
  	<div class="col-7">{{v.tel}}</div>
  </div>
  <div class="row" style="padding-bottom:.5rem;">
  	<div class="col-3">身份证号</div>
  	<div class="col-7">{{v.sfzh}}</div>
  </div>
  <div class="row" style="padding-top:.5rem;border-top:1px solid #eee;" @click="edit(v,i)">
  	<div class="col-3 look">查看详情</div>
  	<div class="col-6"></div>
  	<div class="col-1 center"><i class="fa fa-angle-right"></i></div>
  </div>
</div>

<div class="row pd">
	<mt-button type="primary" size="large" @click="add">新增常用体检人</mt-button>
</div>

<mt-popup v-model="showform" class="popup" position="right">
<div class="row title center" @click="close">
	<i class="fa fa-angle-left"></i>
	新增常用体检人
</div>	

<div class="form">
<div class="row">
	<div class="col-3 left">姓&nbsp;&nbsp;名</div>
	<div class="col-7">
		<mt-field placeholder="请输入姓名" v-model="f.realname"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">性&nbsp;&nbsp;别</div>
	<div class="col-7" style="padding-top:.7rem;">
		<mt-switch v-model="f.sex">{{f.sex?"男":"女"}}</mt-switch>
	</div>
</div>

<div class="row">
	<div class="col-3 left">手机号</div>
	<div class="col-7">
		<mt-field placeholder="请输入手机号码" v-model="f.tel"></mt-field>
	</div>
</div>	

<div class="row">
	<div class="col-3 left">身份证</div>
	<div class="col-7">
		<mt-field placeholder="请输入身份证号码" v-model="f.sfzh"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">婚&nbsp;&nbsp;否</div>
	<div class="col-7">
		<mt-switch v-model="f.marry">{{f.marry?"已婚":"未婚"}}</mt-switch>
	</div>
</div>

<div class="row">
	<div class="col-3 left">微信号</div>
	<div class="col-7">
		<mt-field placeholder="请输入微信号" v-model="f.weixin"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">QQ</div>
	<div class="col-7">
		<mt-field placeholder="请输入qq号码" v-model="f.qq"></mt-field>
	</div>
</div>

</div>

<div class="row pd" v-show="status==2&&f.orderid==0">
	<mt-button type="primary" size="large" @click="subedit">保存修改</mt-button>
</div>

<div class="row pd" v-show="status==2&&f.orderid==0">
	<mt-button  size="large" @click="del">删除联系人</mt-button>
</div>

<div class="row not-edit" v-show="status==2&&f.orderid>0">不允许修改</div>


<div class="row pd" v-show="status==1">
	<mt-button type="primary" size="large" :disabled="savestatus" @click="sub(false)">保 存</mt-button>
</div>

</mt-popup>

</div>
</template>

<style scoped>
.pd{padding:.5rem 1rem;}
.popup{width:100%;height:100%;overflow: auto;background:rgb(251,251,251);}
.container{background: rgb(251,251,251);}	
.myitem{border-radius: .3rem;background: white;padding:.5rem;
	float: left;width:96%;margin:2%;
	border:1px solid #eee;
}
.col-3{color:#adadad;}
.look{color:black;}
.row{margin:.25rem 0;}	
.center i{font-size: 1.5rem;color:#adadad;}
.empty i{font-size: 3rem;}
.empty p{padding:.5rem;}
.title{padding:.5rem;font-size: 1.2rem;color:rgb(0,144,255);border-bottom: .2rem solid #eee;}
.title i{float: left;margin-left:.5rem;color:rgb(0,144,255);}
.mint-button--default{background: white;color:#aaa;}
.not-edit{
    text-align: center;
    background:white;
    padding:.5rem;
    border:1px solid #ddd;
}
</style>

<script>

export default {
	data:function(){
		return {
            list:[],
            showform:false,
            f:{
            	email:"",
            	marry:true,
            	qq:"",
            	realname:"",
            	sex:true,
            	sfzh:"",
            	tel:"",
            	weixin:"",
            	mid:"",
            },
            status:1,
            index:false,
            savestatus:false,
		}
	},
	filters:{
		sex:function(d){
			return d==1?"男":"女";
		}
	},
	created:function(){
		this.$emit("setTitle","常用体检人");
		this.init();
	},
	methods:{
		init:function(){
			var _this=this;
			fun.post(mydata.apiuser+"family",{},function(d){
				console.log(d);
				if(d.status==1){
					_this.list=d.info;
				}else{
					_this.$toast(d.info);
				}
			})
		},
		add:function(){
			this.f={
            	email:"",
            	marry:true,
            	qq:"",
            	realname:"",
            	sex:true,
            	sfzh:"",
            	tel:"",
            	weixin:"",
            };
            this.status=1;
            this.showform=true;
		},
		edit:function(d,i){
			this.status=2;
			var tem=fun.copy(d);
			tem.marry=d.marry==1?true:false;
			tem.sex=d.sex==1?true:false;
			this.f=tem;
			this.index=i;
			this.showform=true;
		},
		close:function(){
			this.showform=false;
		},
		sub:function(i){
			//console.log(i);
			var _this=this;
			this.savestatus=true;
			fun.post(mydata.apiuser+"family_sub",this.f,function(d){
				console.log(d);
				_this.savestatus=false;
				if(d.status==1){
					if(i!==false){
						_this.list.splice(i,1,d.info)
					}else{
						_this.list.push(d.info);
					}
					_this.showform=false;
				}else{
					_this.$toast(d.info);
				}
			})
		},
		subedit:function(){
          this.sub(this.index);
		},
		del:function(){
			var _this=this;
			this.$messagebox.confirm("确定要删除此联系人吗？").then(function(){
				_this.dell();
			},function(){
				console.log("不删除");
			})
		},
		dell:function(){
			var _this=this;
			fun.post(mydata.apiuser+"family_del",this.f,function(d){
				console.log(d);
				_this.$toast(d.info);
				if(d.status==1){
					_this.list.splice(_this.index,1);
					_this.showform=false;
				}
			})

		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/family.vue